module.exports = __webpack_public_path__ + "static/media/centos.5837a49c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/centos.png
// module id = 80
// module chunks = 0